import script from "./TestTaker.vue?vue&type=script&setup=true&lang=js"
export * from "./TestTaker.vue?vue&type=script&setup=true&lang=js"

import "./TestTaker.vue?vue&type=style&index=0&id=fa8d045c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa8d045c"]])

export default __exports__